import React from 'react'

import './index.scss'

export const IndentRight: React.FC = () => (
  <svg className="icon icon--indent-right" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" d="M10 9.61502L5 6.04361L5 13.1864L10 9.61502Z" />
    <rect className="fill" height="2.15625" width="9.0675" x="11.9375" y="5.68199" />
    <rect className="fill" height="2.15625" width="9.0675" x="11.9375" y="11.4738" />
    <rect className="fill" height="2.15625" width="16.005" x="5" y="17.2656" />
  </svg>
)
